module.exports = __webpack_public_path__ + "img/10ne.556a47b2.svg";